'use client'
import { ChevronRight } from 'lucide-react'
import { updateLoginData } from '@/lib/reducers/loginReducer'
import { dispatch, useSelector } from '@/lib/store'
import { FeatureDataProps } from '@/utils/interfaces'
import { Fragment } from 'react'
import {CURRENT_SUBSIDIARY, CONSUMER_WEB_PLATFORM, NEARBY_LABS_PAGE , SUBSIDIARY_CONFIG } from '@/utils/constants'
import CustomFeatureLinkOrButton from './CustomFeatureLinkOrButton'
import { eventConstants, trackEvent } from '@/utils/events'
import { loadState } from '@/utils/localStorage'

const Features = ({
  text,
  title,
  description,
  onClick,
  icon,
  isLoginNeeded,
}: FeatureDataProps) => {
  const { WHATSAPP_URL_WEBPAGE } = SUBSIDIARY_CONFIG

  const loginState = useSelector((state) => state.login) || {}
  const cityState = useSelector((state) => state.city)
  const loggedInMobileNumber = loadState('ctxVal') || null

  const handleGetBackgroundColor = (text: string) => {
    switch (text) {
      case 'case1':
        return 'bg-[#E5F5EC]'
      case 'case2':
        return 'bg-[#DBF0FF]'
      case 'case3':
        return 'bg-[#F6ECDD]'
      case 'case4':
        return 'bg-[#EDE8FC]'
    }
  }

  const handleClick = () => {
    if (isLoginNeeded && !loginState?.isUserLoggedIn) {
      dispatch(updateLoginData({ ...loginState, loginModalIsOpen: true }))
    } else {
      if (text === 'case1') {

      const eventPayload = {
            u_mb: loggedInMobileNumber || '',
            city: cityState?.currentCityObj?.name || null,
            app: CONSUMER_WEB_PLATFORM,
            subsidiary: CURRENT_SUBSIDIARY,
          }
      trackEvent(eventConstants.BOOK_VIA_WHATSAPP, eventPayload)
      setTimeout(() => onClick(), 200)
      return
    }
    onClick()
  }
}


  return (
    <Fragment>
      <CustomFeatureLinkOrButton
        as={text === 'case1' || text === 'case4' ? 'link' : 'button'}
        href={text === 'case1' ? WHATSAPP_URL_WEBPAGE : text === 'case4' ? NEARBY_LABS_PAGE : '#'}
        onClick={handleClick}
        className="p-0 m-0 w-full block bg-transparent shadow-none border-none h-auto text-left"
      >
        <div
          className={`group relative flex flex-row gap-3 items-center justify-between ${handleGetBackgroundColor(text)} border border-transparent rounded-xl p-3 shadow-[0_1px_3px_rgba(0,0,0,0.06)] hover:shadow-[0_4px_16px_rgba(0,102,204,0.1)] transition-all duration-300 ease-out h-full`}
          role="presentation"
        >
          <div className="flex flex-row gap-3 items-center min-w-0 w-full">
            <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0">
              {icon}
            </div>
            <div className="min-w-0 flex-1 text-wrap">
              <p className="text-label-sm md:text-label-md font-semibold text-gray-800 group-hover:text-primary-700 transition-colors duration-300 leading-tight">
                {title}
              </p>
            </div>
          </div>
          <ChevronRight size={20} className="text-gray-400 flex-shrink-0 hidden md:block" />
        </div>
      </CustomFeatureLinkOrButton>
    </Fragment>
  )
}

export default Features
